import dayjs from 'dayjs'
import { useLayoutEffect, useState } from 'react'

// 今日の日付を取得する
export const getToday = () => {
  const today = new Date()
  const dd = String(today.getDate()).padStart(2, '0')
  const mm = String(today.getMonth() + 1).padStart(2, '0')
  const yyyy = today.getFullYear()
  const todayDate = mm + '/' + dd + '/' + yyyy

  const estimateDate = dayjs(todayDate).format('YYYY-MM-DD')

  return estimateDate
}

// tagのcssのカラーを取得する
export const getColor = (statusCode: number) => {
  const color = ''
  switch (statusCode) {
    case 100:
    case 110:
    case 120:
      return 'warning'
    case 200:
      return 'processing'
    case 300:
    case 310:
      return 'success'
  }
  return color
}

export const useWindowSize = (): [number, number] => {
  const [size, setSize] = useState<[number, number]>([0, 0])

  useLayoutEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight])
    }

    window.addEventListener('resize', updateSize)
    updateSize()

    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return size
}
